import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayName',
  standalone: true,
})
export class DisplayNamePipe implements PipeTransform {
  transform(
    value: string,
    list: any[],
    match = 'id',
    display = 'name'
  ): string {
    return list.find((item) => item[match] === value)?.[display] ?? value;
  }
}
